import { useState } from 'react'
import { TableCard } from '../../../../components'
import { AtendimentoEstadoCards } from './component/header/AtendimentoEstadoCards'
import { AtendimentoMedicoListSearchComponent } from './component/header/AtendimentoMedicoListSearchComponent'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { AtendimentoMedicoTable } from './table/AtendimentoMedicoTable'

const AtendimentoMedicoList = () => {
  // Estado selecionado nos cards (sempre há um; não é chip nem entra no "Limpar").
  const [estado, setEstado] = useState(1)

  return (
    <>
      <AtendimentoEstadoCards estado={estado} onChange={setEstado} />
      <TableCard>
        <AtendimentoMedicoListSearchComponent estado={estado} />
        <AtendimentoMedicoTable />
      </TableCard>
    </>
  )
}

export const AtendimentoMedicoListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListFiltersProvider>
        <AtendimentoMedicoList />
      </ListFiltersProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
